import { tw } from "@/utils";

// 테이블 공통 스타일

// 헤더 텍스트 공통 스타일
export const tableHeaderStyle = tw(
  "flex w-full h-[62px] items-center",
  "border-solid border-b-[1px] border-gray-g30",
  "*:px-[24px] *: pt-[20px]",
  "*:text-base *:font-medium *:text-gray-g200 *:overflow-hidden *:text-ellipsis"
);

export const smallTableHeaderStyle = tw(
  "flex w-full h-[34px] items-center bg-gray-g10",
  "*:px-[10px] *:text-sm *:font-medium *:text-gray-g400 *:overflow-hidden *:text-ellipsis"
);

// row 텍스트 공통 스타일
export const tableRowTextStyle = () =>
  tw(
    "w-full h-[50px] flex items-center",
    "*:h-full *:px-[24px] *:flex *:items-center",
    "*:border-solid *:border-b-[1px] *:border-l-[1px] *:first:border-l-0 *:border-gray-g30",
    "*:text-base font-medium *:text-gray-g400 *:whitespace-pre *:overflow-hidden *:text-ellipsis"
  );

export const smallTableRowTextStyle = () =>
  tw(
    "w-full h-[38px] flex items-center",
    "*:h-full *:px-[10px] *:flex *:items-center",
    "*:border-solid *:border-t-[1px] *:border-l-[1px] *:first:border-l-0 *:border-gray-g30",
    "*:text-base font-medium *:text-gray-g500 *:overflow-hidden *:text-ellipsis"
  );
